export const REACOES_RAPIDAS = ['👍', '❤️', '😂', '😮', '😢', '🙏'];
